import { Modal } from '../Modal';
import { Button } from '../Button';

interface DeleteConnectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  deleting: boolean;
}

export const DeleteConnectionModal = ({
  isOpen,
  onClose,
  onDelete,
  deleting,
}: DeleteConnectionModalProps) => {
  return (
    <Modal
      title="Delete Connection"
      isOpen={isOpen}
      onClose={onClose}
      actionButton={
        <Button onClick={onDelete} disabled={deleting}>
          {deleting ? 'Deleting...' : 'Delete'}
        </Button>
      }
      className="w-96"
    >
      <div className="text-center">
        Are you sure you want to delete this connection? This action cannot be
        undone.
      </div>
    </Modal>
  );
};
